// src/components/VantaBackground.js
import React, { useEffect } from 'react';

const VantaBackground = () => {
  useEffect(() => {
    // Ensure that the global VANTA object and NET effect are loaded
    if (window.VANTA && window.VANTA.NET) {
      window.VANTA.NET({
        el: "#vanta-bg", // target the div in index.html
        mouseControls: true,
        touchControls: true,
        gyroControls: true,
        minHeight: 200.00,
        minWidth: 200.00,
        scale: 1.00,
        scaleMobile: 1.00,
        color: 0x3cb38e,
        backgroundColor: 0x141414,
        points: 11.00,
        maxDistance: 26.00,
        spacing: 16.00
})
    } else {
      console.error("VANTA or VANTA.NET is not available on window.");
    }
  }, []);

  return null; // This component doesn't render any extra DOM elements
};

export default VantaBackground;
